import request from '@/utils/request'

// 单个活动可添加的关键字列表
export function fetchKeywordsListByActivityId(data) {
  return request({
    url: '/market/keywords/list',
    method: 'get',
    params: data,
  })
}

// 根据语言获取关键字列表
export function fetchKeywordsListByLanguage(data) {
  return request({
    url: '/market/keywords/bylanguag',
    method: 'get',
    params: data,
  })
}

// 所有活动列表
export function fetchGetActivities() {
  return request({
    url: '/market/keywords/marketing/activities',
    method: 'get',
  })
}

// 关键字绑定活动
export function fetchAddKeywordToActivity(data) {
  return request({
    url: '/market/keywords/add',
    method: 'post',
    data,
  })
}

// 创建活动
export function fetchCreateActivity(data) {
  return request({
    url: '/market/activity/add',
    method: 'post',
    data,
  })
}

// 删除活动
export function fetchDeleteActivity(data) {
  return request({
    url: '/market/activity/del',
    method: 'delete',
    data,
  })
}
